export const GO_TO_WALLET_URL = '/wallet/balance'
